const Logo = (props) => (
  <img alt="Logo" src="/icons/logo-min.png" {...props}/>
);

export default Logo;
